module.exports = __webpack_public_path__ + "img/see_more_black.77f59f81.svg";